module.exports = __webpack_public_path__ + "static/media/12.16c388ca.jpg";